import { render, staticRenderFns } from "./jumpbaijia.vue?vue&type=template&id=79fbe376&scoped=true"
import script from "./jumpbaijia.vue?vue&type=script&lang=js"
export * from "./jumpbaijia.vue?vue&type=script&lang=js"
import style0 from "./jumpbaijia.vue?vue&type=style&index=0&id=79fbe376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fbe376",
  null
  
)

export default component.exports